<div class="messaging-preview-container">
    <div class="preview-header">
        <span class="preview-title">{{ 'bikeshop.workshop.jobcard.manage.messages' | translate }}</span>
    </div>

    <div class="preview-content" *ngIf="messages && messages.length > 0">
        <div *ngFor="let message of getSortedMessages().slice(0, 4); let i = index" class="message-preview-item">
            <div *ngIf="shouldShowDateSeparator(message, i)" class="date-separator">
                <span class="date-text">{{ getDateDisplayText(message.CreatedDate) }}</span>
            </div>

            <!-- Message Preview -->
            <div class="message-content" [ngClass]="{'incoming': message.Direction === 'Incoming','outgoing': message.Direction === 'Outgoing'}">
                <div class="message-header">
                    <div class="message-info">
                        <span class="message-direction">
                            {{ message.Direction === 'Incoming' ? (jobcard.customer.Name + " " + jobcard.customer.Surname) : getMessageTypeLabel(message.Type) }}
                        </span>
                    </div>
                    <div class="message-time">
                        {{ message.CreatedDate+'Z' | date: countryData.AngularDateFormat + ' h:mm a' }}
                    </div>
                </div>

                <div class="message-text">
                    {{ truncateMessage(message.Message) }}
                </div>

                <div class="status" *ngIf="message.Direction === 'Outgoing' && message.DeliveryStatus">
                    <div *ngIf="message.DeliveryStatus == 'accepted' || message.DeliveryStatus == 'sent'">
                        <span class="fa fa-check"></span>
                    </div>
                    <div *ngIf="message.DeliveryStatus == 'delivered'" class="double-check">
                        <span class="fa fa-check"></span><span class="fa fa-check"></span>
                    </div>
                    <div *ngIf="message.DeliveryStatus == 'read'" class="double-check read">
                        <span class="fa fa-check"></span><span class="fa fa-check"></span>
                    </div>
                    <div *ngIf="message.DeliveryStatus == 'failed'" class="failed"><span
                            class="fa fa-exclamation-triangle" pTooltip="{{ message.FailureReason }}"></span></div>
                </div>
            </div>
        </div>

        <div class="more-messages" *ngIf="messages.length > 4">
            <span>{{ 'bikeshop.modal.update_job_card.messaging_preview.x_more_messages' | translate: { count:
                messages.length - 4 } }}</span>
        </div>
    </div>

</div>